import React, { Fragment } from 'react'
import { Breadcrumbs } from '../../../../../AbstractElements';
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import MonthlySalesTrendReportView from './MonthlySalesTrendReportView'

const MonthlySalesTrendReport = () => {
    return (
        <Fragment>
            <Breadcrumbs parent="Report" title="Monthly Sales Trend Report" mainTitle="Monthly Sales Trend Report" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <MonthlySalesTrendReportView />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default MonthlySalesTrendReport